// Build configuration must name the deployed native API, never a retired account endpoint.
export function requiredConfig(name, value) {
  if (!value?.trim())
    throw new Error(`${name} must be configured for Factor Mind`);
  return value.trim();
}
export const API_BASE = requiredConfig(
  'REACT_APP_API_BASE_URL',
  process.env.REACT_APP_API_BASE_URL,
).replace(/\/+$/, '');
